import { render, staticRenderFns } from "./fieldOpinionResponse.vue?vue&type=template&id=ef5e2dfe&scoped=true&"
import script from "./fieldOpinionResponse.vue?vue&type=script&lang=js&"
export * from "./fieldOpinionResponse.vue?vue&type=script&lang=js&"
import style0 from "./fieldOpinionResponse.vue?vue&type=style&index=0&id=ef5e2dfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5e2dfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/bsx-uat.dianthus.com.tw/backstage_orig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef5e2dfe')) {
      api.createRecord('ef5e2dfe', component.options)
    } else {
      api.reload('ef5e2dfe', component.options)
    }
    module.hot.accept("./fieldOpinionResponse.vue?vue&type=template&id=ef5e2dfe&scoped=true&", function () {
      api.rerender('ef5e2dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/vueFormFieldComponents/fieldOpinionResponse.vue"
export default component.exports